import cateringOrder from '@/components/page/catering/cateringOrder'
import cateringDetail from '@/components/page/catering/cateringDetail'
import cateringCreate from '@/components/page/catering/cateringCreate'

export default [
  {
    path: '/cateringOrder',
    name: 'cateringOrder',
    component: () => import ('@/components/page/catering/cateringOrder')
  },
  {
    path: '/cateringDetail',
    name: 'cateringDetail',
    component: () => import ('@/components/page/catering/cateringDetail')
  },
  {
    path: '/cateringCreate',
    name: 'cateringCreate',
    component: () => import ('@/components/page/catering/cateringCreate')
  },
]



// WEBPACK FOOTER //
// ./src/router/modules/catering.js